import { render, staticRenderFns } from "./IndicatorWorkDays.vue?vue&type=template&id=2f9984d8&scoped=true&"
import script from "./IndicatorWorkDays.vue?vue&type=script&lang=js&"
export * from "./IndicatorWorkDays.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorWorkDays.vue?vue&type=style&index=0&id=2f9984d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9984d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VSkeletonLoader})
